/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScoringCapability } from './ScoringCapability';
import {
    ScoringCapabilityFromJSON,
    ScoringCapabilityFromJSONTyped,
    ScoringCapabilityToJSON,
    ScoringCapabilityToJSONTyped,
} from './ScoringCapability';
import type { CompetitionConfigEnabledTypes } from './CompetitionConfigEnabledTypes';
import {
    CompetitionConfigEnabledTypesFromJSON,
    CompetitionConfigEnabledTypesFromJSONTyped,
    CompetitionConfigEnabledTypesToJSON,
    CompetitionConfigEnabledTypesToJSONTyped,
} from './CompetitionConfigEnabledTypes';

/**
 * Unified Competition Configuration for a game
 * @export
 * @interface CompetitionConfig
 */
export interface CompetitionConfig {
    /**
     * 
     * @type {ScoringCapability}
     * @memberof CompetitionConfig
     */
    scoringCapability?: ScoringCapability;
    /**
     * 
     * @type {CompetitionConfigEnabledTypes}
     * @memberof CompetitionConfig
     */
    enabledCompetitionTypes?: CompetitionConfigEnabledTypes;
}



/**
 * Check if a given object implements the CompetitionConfig interface.
 */
export function instanceOfCompetitionConfig(value: object): value is CompetitionConfig {
    return true;
}

export function CompetitionConfigFromJSON(json: any): CompetitionConfig {
    return CompetitionConfigFromJSONTyped(json, false);
}

export function CompetitionConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'scoringCapability': json['scoringCapability'] == null ? undefined : ScoringCapabilityFromJSON(json['scoringCapability']),
        'enabledCompetitionTypes': json['enabledCompetitionTypes'] == null ? undefined : CompetitionConfigEnabledTypesFromJSON(json['enabledCompetitionTypes']),
    };
}

export function CompetitionConfigToJSON(json: any): CompetitionConfig {
    return CompetitionConfigToJSONTyped(json, false);
}

export function CompetitionConfigToJSONTyped(value?: CompetitionConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scoringCapability': ScoringCapabilityToJSON(value['scoringCapability']),
        'enabledCompetitionTypes': CompetitionConfigEnabledTypesToJSON(value['enabledCompetitionTypes']),
    };
}

